import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DeRoomClass, RoomClass, RoomClassCodes, ROOM_TYPE, twinRoomImprovedSpecialRequests, twinRoomStandardSpecialRequests, ACCESSIBLE_ROOM_TYPES, ACCESSIBLE_BARRIER_ROOM_TYPES, HotelBrand, RoomClassLabelByCode, ACCESSIBLE_ROOM_TYPE, roomTypeMapping, wetBathRoomTypes, loweredBathRoomTypes, PREMIER_PLUS_ACCESSIBLE, ACCESSIBLE, GET_DASHBOARD_BASKET } from '@whitbread-eos/api';
import { add, differenceInDays, format } from 'date-fns';
import { MAX_ROOMS_SEARCH_LIMIT } from '../global-constants';
import { executeGraphQLQuery } from '../server';
import { staticHotelInformationIB, getHotelInformationIB } from '../server/getters/getters';
import { isDateValid } from '../validators';
export function getAvailabilityParamsFromUrl(url) {
  var isNoRoomTypeSearchEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var urlParams = new URLSearchParams(url);
  var year = Number(urlParams.get('ARRyyyy'));
  var month = Number(urlParams.get('ARRmm'));
  var day = Number(urlParams.get('ARRdd'));
  var numberOfNights = Number(urlParams.get('NIGHTS'));
  var numberOfRooms = Number(urlParams.get('ROOMS'));
  var cellCodes = urlParams.get('CELLCODES');
  var empOfferCodes = (cellCodes === null || cellCodes === void 0 ? void 0 : cellCodes.split(',')) || [];
  var corpId = urlParams.get('CORPID');
  var promoId = urlParams.get('PROMOID');
  var arrivalDate = isDateValid(day, month, year) ? new Date(year, month - 1, day) : new Date();
  var arrival = format(arrivalDate, 'yyyy-MM-dd');
  var departure = format(add(arrivalDate, {
    days: numberOfNights
  }), 'yyyy-MM-dd');
  var rooms = [];
  for (var idx = 0; idx < numberOfRooms && idx < MAX_ROOMS_SEARCH_LIMIT; idx++) {
    rooms.push({
      adultsNumber: Number(urlParams.get("ADULT".concat(idx + 1))),
      childrenNumber: Number(urlParams.get("CHILD".concat(idx + 1))),
      roomType: isNoRoomTypeSearchEnabled ? '' : urlParams.get("INTTYP".concat(idx + 1)),
      cotRequired: urlParams.get("COT".concat(idx + 1)) === '1'
    });
  }
  return {
    arrival,
    departure,
    rooms,
    empOfferCodes,
    corpId,
    promoId,
    numberOfNights
  };
}
export function getStaticHotelInformationQueryDateDataFromUrl(url) {
  var _url$split$;
  var queryString = url !== null && url !== void 0 && url.includes('?') ? (_url$split$ = url.split('?')[1]) !== null && _url$split$ !== void 0 ? _url$split$ : '' : url;
  var urlParams = new URLSearchParams(queryString);
  var year = Number(urlParams.get('ARRyyyy'));
  var month = Number(urlParams.get('ARRmm'));
  var day = Number(urlParams.get('ARRdd'));
  var numberOfNights = Number(urlParams.get('NIGHTS'));
  var hasValidStayDates = isDateValid(day, month, year) && Number.isFinite(numberOfNights) && numberOfNights > 0;
  if (!hasValidStayDates) {
    return {
      staticHotelInformationQueryKeyDates: [],
      staticHotelInformationQueryPayloadDates: {}
    };
  }
  var arrivalDate = new Date(year, month - 1, day);
  var stayStartDate = format(arrivalDate, 'yyyy-MM-dd');
  var stayEndDate = format(add(arrivalDate, {
    days: numberOfNights
  }), 'yyyy-MM-dd');
  return {
    staticHotelInformationQueryKeyDates: [stayStartDate, stayEndDate],
    staticHotelInformationQueryPayloadDates: {
      stayStartDate,
      stayEndDate
    }
  };
}
export function getHotelAvailabilityQueryKey(language, country, brand, hotelId, arrival, departure, rooms) {
  var empOfferCodes = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  var landingPagePromoCode = arguments.length > 8 ? arguments[8] : undefined;
  var promoKind = arguments.length > 9 ? arguments[9] : undefined;
  var softBundle = arguments.length > 10 ? arguments[10] : undefined;
  var rateName = arguments.length > 11 ? arguments[11] : undefined;
  var roomClass = arguments.length > 12 ? arguments[12] : undefined;
  var isPromoBox = arguments.length > 13 ? arguments[13] : undefined;
  var hotelAvailabilityQueryKey = ['hotelAvailability', language, country, brand === null || brand === void 0 ? void 0 : brand.toLowerCase(), hotelId, arrival, departure, JSON.stringify(rooms), JSON.stringify(empOfferCodes)];
  if (landingPagePromoCode) {
    hotelAvailabilityQueryKey.push(landingPagePromoCode);
  }
  if (promoKind) {
    hotelAvailabilityQueryKey.push(promoKind);
  }
  if (softBundle) {
    hotelAvailabilityQueryKey.push(softBundle);
  }
  if (rateName) {
    hotelAvailabilityQueryKey.push(rateName);
  }
  if (roomClass) {
    hotelAvailabilityQueryKey.push(roomClass);
  }
  if (isPromoBox) {
    hotelAvailabilityQueryKey.push(isPromoBox);
  }
  return hotelAvailabilityQueryKey;
}
export function isHotelOpeningSoon(hotelOpeningDate, arrival) {
  if (!hotelOpeningDate || !arrival) {
    return false;
  }
  try {
    return differenceInDays(new Date(hotelOpeningDate), new Date(arrival)) > 0;
  } catch (e) {
    return false;
  }
}
export function getAvailableRoomTypes() {
  var roomTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return Array.from(new Set(roomTypes === null || roomTypes === void 0 ? void 0 : roomTypes.map(type => type === null || type === void 0 ? void 0 : type.roomType)));
}
export function getAllRoomTypesFromRates(roomRates) {
  var allRoomTypes = [];
  roomRates.forEach(roomRate => {
    var _roomRate$roomTypes;
    return roomRate === null || roomRate === void 0 || (_roomRate$roomTypes = roomRate.roomTypes) === null || _roomRate$roomTypes === void 0 ? void 0 : _roomRate$roomTypes.forEach(room => {
      allRoomTypes.push(room);
    });
  });
  return allRoomTypes;
}
export function getRoomClassByRoomClassCode(roomClassCode, language) {
  return language === 'en' ? RoomClass[roomClassCode] : DeRoomClass[roomClassCode];
}
export function getRateClassification(ratePlanCode) {
  var rateClassifications = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return rateClassifications.find(rate => (rate === null || rate === void 0 ? void 0 : rate.rateClassification) === ratePlanCode || (rate === null || rate === void 0 ? void 0 : rate.ratePlanCode) === ratePlanCode);
}
export function getRoomRatesThatMatchRoomClassifications(rateClassifications) {
  var roomRates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return [...roomRates].sort((roomRate1, roomRate2) => {
    var _rateClassifications$, _rateClassifications$2;
    var rate1Order = (_rateClassifications$ = rateClassifications.find(el => (el === null || el === void 0 ? void 0 : el.rateClassification) === (roomRate1 === null || roomRate1 === void 0 ? void 0 : roomRate1.ratePlanCode))) === null || _rateClassifications$ === void 0 ? void 0 : _rateClassifications$.rateOrder;
    var rate2Order = (_rateClassifications$2 = rateClassifications.find(el => (el === null || el === void 0 ? void 0 : el.rateClassification) === (roomRate2 === null || roomRate2 === void 0 ? void 0 : roomRate2.ratePlanCode))) === null || _rateClassifications$2 === void 0 ? void 0 : _rateClassifications$2.rateOrder;
    return rate1Order && rate2Order ? +rate1Order - +rate2Order : 0;
  });
}
export function getAvailabilityRoomClassIndexes() {
  var _roomRates$;
  var roomRates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var availableRoomTypes = getAvailableRoomTypes(getAllRoomTypesFromRates(roomRates));
  var STANDARD_ROOM = RoomClassCodes.STANDARD_ROOM;
  return (availableRoomTypes === null || availableRoomTypes === void 0 ? void 0 : availableRoomTypes.length) > 1 ? [STANDARD_ROOM] : (_roomRates$ = roomRates[0]) === null || _roomRates$ === void 0 || (_roomRates$ = _roomRates$.roomTypes[0].rooms) === null || _roomRates$ === void 0 ? void 0 : _roomRates$.map(room => room === null || room === void 0 ? void 0 : room.roomClass);
}
export function getSelectedPMSRoomTypesAndSpecialRequests(twinroomSelections, basketDetailsState) {
  var _basketDetailsState$s;
  var selectedPMSRoomTypes = [];
  var selectedSpecialRequests = [];
  var roomIndex = 0;
  (_basketDetailsState$s = basketDetailsState.selectedRate) === null || _basketDetailsState$s === void 0 || (_basketDetailsState$s = _basketDetailsState$s.roomTypes) === null || _basketDetailsState$s === void 0 || _basketDetailsState$s.forEach(roomType => {
    var _roomType$rooms3, _roomType$rooms4, _isTwoBeds$specialReq, _isDoubleSofa$special;
    if ((roomType === null || roomType === void 0 ? void 0 : roomType.roomType) !== ROOM_TYPE.TWIN) {
      var _roomType$rooms, _roomType$rooms2;
      roomIndex++;
      selectedSpecialRequests.push(roomType === null || roomType === void 0 || (_roomType$rooms = roomType.rooms) === null || _roomType$rooms === void 0 || (_roomType$rooms = _roomType$rooms[0]) === null || _roomType$rooms === void 0 ? void 0 : _roomType$rooms.specialRequests);
      return selectedPMSRoomTypes.push(roomType === null || roomType === void 0 || (_roomType$rooms2 = roomType.rooms) === null || _roomType$rooms2 === void 0 || (_roomType$rooms2 = _roomType$rooms2[0]) === null || _roomType$rooms2 === void 0 ? void 0 : _roomType$rooms2.pmsRoomType);
    }
    var matchTwinRoomSelection = twinroomSelections[roomIndex];
    var isTwoBeds = roomType === null || roomType === void 0 || (_roomType$rooms3 = roomType.rooms) === null || _roomType$rooms3 === void 0 ? void 0 : _roomType$rooms3.find(roomItem => twinRoomImprovedSpecialRequests.includes(roomItem === null || roomItem === void 0 ? void 0 : roomItem.specialRequests[0]));
    var isDoubleSofa = roomType === null || roomType === void 0 || (_roomType$rooms4 = roomType.rooms) === null || _roomType$rooms4 === void 0 ? void 0 : _roomType$rooms4.find(roomItem => twinRoomStandardSpecialRequests.includes(roomItem === null || roomItem === void 0 ? void 0 : roomItem.specialRequests[0]));
    if (matchTwinRoomSelection === ROOM_TYPE.TWIN_TWO_BEDS && isTwoBeds !== null && isTwoBeds !== void 0 && (_isTwoBeds$specialReq = isTwoBeds.specialRequests) !== null && _isTwoBeds$specialReq !== void 0 && _isTwoBeds$specialReq.length) {
      selectedSpecialRequests.push(isTwoBeds === null || isTwoBeds === void 0 ? void 0 : isTwoBeds.specialRequests);
      selectedPMSRoomTypes.push(isTwoBeds === null || isTwoBeds === void 0 ? void 0 : isTwoBeds.pmsRoomType);
    }
    if (matchTwinRoomSelection === ROOM_TYPE.TWIN_DOUBLE_SOFA && isDoubleSofa !== null && isDoubleSofa !== void 0 && (_isDoubleSofa$special = isDoubleSofa.specialRequests) !== null && _isDoubleSofa$special !== void 0 && _isDoubleSofa$special.length) {
      selectedSpecialRequests.push(isDoubleSofa === null || isDoubleSofa === void 0 ? void 0 : isDoubleSofa.specialRequests);
      selectedPMSRoomTypes.push(isDoubleSofa === null || isDoubleSofa === void 0 ? void 0 : isDoubleSofa.pmsRoomType);
    }
    roomIndex++;
  });
  return {
    selectedPMSRoomTypes,
    selectedSpecialRequests
  };
}
export function getTwinRoomSelectionPrices(selectedRate) {
  var _selectedRate$roomTyp;
  return selectedRate === null || selectedRate === void 0 || (_selectedRate$roomTyp = selectedRate.roomTypes) === null || _selectedRate$roomTyp === void 0 || (_selectedRate$roomTyp = _selectedRate$roomTyp.find(selectedType => (selectedType === null || selectedType === void 0 ? void 0 : selectedType.roomType) === ROOM_TYPE.TWIN)) === null || _selectedRate$roomTyp === void 0 || (_selectedRate$roomTyp = _selectedRate$roomTyp.rooms) === null || _selectedRate$roomTyp === void 0 || (_selectedRate$roomTyp = _selectedRate$roomTyp.map(room => {
    var _room$roomPriceBreakd, _room$roomPriceBreakd2;
    var hasTwinOptions = element => element === twinRoomImprovedSpecialRequests[0] || element === twinRoomStandardSpecialRequests[0];
    var typeIndex = room.specialRequests.findIndex(hasTwinOptions);
    return {
      twinRoomType: room === null || room === void 0 ? void 0 : room.specialRequests[typeIndex],
      currencyCode: room === null || room === void 0 || (_room$roomPriceBreakd = room.roomPriceBreakdown) === null || _room$roomPriceBreakd === void 0 ? void 0 : _room$roomPriceBreakd.currencyCode,
      price: room === null || room === void 0 || (_room$roomPriceBreakd2 = room.roomPriceBreakdown) === null || _room$roomPriceBreakd2 === void 0 ? void 0 : _room$roomPriceBreakd2.totalNetAmount
    };
  })) === null || _selectedRate$roomTyp === void 0 ? void 0 : _selectedRate$roomTyp.filter((value, index, self) => {
    return self.findIndex(room => (room === null || room === void 0 ? void 0 : room.twinRoomType) === (value === null || value === void 0 ? void 0 : value.twinRoomType)) === index;
  });
}
export function getRoomTypesFromQuery(routerQuery, mapping, roomLabel, maxRooms) {
  var roomTypes = [];
  var numberOfRooms = parseInt(routerQuery['ROOMS']) || 1;
  var roomsUpperBound = Math.min(maxRooms || MAX_ROOMS_SEARCH_LIMIT, MAX_ROOMS_SEARCH_LIMIT);
  for (var i = 1; i <= numberOfRooms && i <= roomsUpperBound; i++) {
    var inttypKey = "INTTYP".concat(i);
    var queryValue = routerQuery[inttypKey];
    roomTypes.push(mapping[queryValue] + ' ' + roomLabel);
  }
  return roomTypes;
}
export function isFaqValidForRender(faq, isFaqEnabled) {
  var _faq$faqItems;
  return faq && !!Object.keys(faq).length && !!(faq !== null && faq !== void 0 && (_faq$faqItems = faq.faqItems) !== null && _faq$faqItems !== void 0 && _faq$faqItems.length) && isFaqEnabled;
}
export function getAccessibleRoomData(roomTypes) {
  var chooseRoomTypePage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return roomTypes === null || roomTypes === void 0 ? void 0 : roomTypes.map(roomType => {
    var _roomType$rooms5;
    var accessibleRooms = roomType === null || roomType === void 0 || (_roomType$rooms5 = roomType.rooms) === null || _roomType$rooms5 === void 0 ? void 0 : _roomType$rooms5.filter(room => {
      if (chooseRoomTypePage) {
        return ACCESSIBLE_BARRIER_ROOM_TYPES.includes(room === null || room === void 0 ? void 0 : room.pmsRoomType);
      }
      return isAccessibleRoomType(room === null || room === void 0 ? void 0 : room.pmsRoomType);
    });
    return _objectSpread(_objectSpread({}, roomType), {}, {
      rooms: accessibleRooms !== null && accessibleRooms !== void 0 && accessibleRooms.length ? accessibleRooms : roomType === null || roomType === void 0 ? void 0 : roomType.rooms,
      isRoomAccessible: !!(accessibleRooms !== null && accessibleRooms !== void 0 && accessibleRooms.length)
    });
  });
}
export function isAccessibleRoomType(roomType) {
  return ACCESSIBLE_ROOM_TYPES === null || ACCESSIBLE_ROOM_TYPES === void 0 ? void 0 : ACCESSIBLE_ROOM_TYPES.includes(roomType);
}
export function getPIBrandText(t, brand) {
  return brand === HotelBrand.PI || brand === HotelBrand.PID ? " ".concat(t('search.new.premierInn'), " ") : ' ';
}
export function isPremierPlusAccessibleRoomByCode(roomClassCode, roomType, isPremPlusAccFeatureFlag) {
  return roomClassCode === RoomClassCodes.PREMIER_PLUS_ROOM && roomType === ACCESSIBLE_ROOM_TYPE && isPremPlusAccFeatureFlag;
}
var staticHotelData = (roomClassConfiguration, roomClassCode) => {
  var hotelData = roomClassConfiguration.filter(item => (item === null || item === void 0 ? void 0 : item.code) == roomClassCode ? item === null || item === void 0 ? void 0 : item.title : '');
  if (hotelData !== null && hotelData !== void 0 && hotelData.length) {
    return hotelData.map(item => item.title).join(', ');
  }
  return hotelData;
};
export function getRoomClassByCodeAndType(roomClass, roomClassCode, roomType, roomTypes, t, isPremPlusAccFeatureFlag, roomClassConfiguration) {
  var staticHotel = staticHotelData(roomClassConfiguration !== null && roomClassConfiguration !== void 0 ? roomClassConfiguration : [], roomClassCode);
  return staticHotel && staticHotel.length > 0 ? staticHotel : RoomClassLabelByCode[roomClassCode] ? t(RoomClassLabelByCode[roomClassCode]) : roomClass;
}
export function isPremierPlusAccessibleRoomByText(roomClass, language) {
  var _ref, _roomClass$toLowerCas;
  var matchStr = (_ref = language === 'en' ? RoomClass.PP : DeRoomClass.PP) === null || _ref === void 0 ? void 0 : _ref.toLowerCase();
  return roomClass === null || roomClass === void 0 || (_roomClass$toLowerCas = roomClass.toLowerCase()) === null || _roomClass$toLowerCas === void 0 ? void 0 : _roomClass$toLowerCas.includes(matchStr);
}
export function getSelectedRoomClassCode(roomClassName, language) {
  var roomClassObject = language === 'en' ? RoomClass : DeRoomClass;
  return Object.keys(roomClassObject).find(key => roomClassObject[key] === roomClassName);
}
export var createRoomTypeMapping = t => {
  var accessibleDouble = t('accessible.double');
  var accessibleTwin = t('accessible.twin');
  return {
    [accessibleDouble]: {
      [ROOM_TYPE.LOWERED]: ROOM_TYPE.LOWERED_DOUBLE,
      [ROOM_TYPE.WET]: ROOM_TYPE.WET_DOUBLE,
      premierPlus: {
        [ROOM_TYPE.LOWERED]: ROOM_TYPE.PREMIER_PLUS_LOWERED_DOUBLE,
        [ROOM_TYPE.WET]: ROOM_TYPE.PREMIER_PLUS_WET_DOUBLE
      }
    },
    [accessibleTwin]: {
      [ROOM_TYPE.LOWERED]: ROOM_TYPE.LOWERED_TWIN,
      [ROOM_TYPE.WET]: ROOM_TYPE.WET_TWIN
    }
  };
};
export function getPMSRoomTypeByRoomTypeAndBathroom(t, isPremPlusAccFeatureFlag, accessibleRoomIndex, roomTypeSelections, bathroomSelections, isPremierPlusAccessibleRoomSelected) {
  var roomType = roomTypeSelections[accessibleRoomIndex];
  var bathRoomType = bathroomSelections[accessibleRoomIndex];
  var mapping = createRoomTypeMapping(t);
  if (isPremPlusAccFeatureFlag) {
    var _mapping$roomType, _mapping$roomType2;
    return isPremierPlusAccessibleRoomSelected ? (_mapping$roomType = mapping[roomType]) === null || _mapping$roomType === void 0 || (_mapping$roomType = _mapping$roomType.premierPlus) === null || _mapping$roomType === void 0 ? void 0 : _mapping$roomType[bathRoomType] : (_mapping$roomType2 = mapping[roomType]) === null || _mapping$roomType2 === void 0 ? void 0 : _mapping$roomType2[bathRoomType];
  } else {
    var _roomTypeMapping$room, _roomTypeMapping$room2;
    return isPremierPlusAccessibleRoomSelected ? (_roomTypeMapping$room = roomTypeMapping[roomType]) === null || _roomTypeMapping$room === void 0 || (_roomTypeMapping$room = _roomTypeMapping$room.premierPlus) === null || _roomTypeMapping$room === void 0 ? void 0 : _roomTypeMapping$room[bathRoomType] : (_roomTypeMapping$room2 = roomTypeMapping[roomType]) === null || _roomTypeMapping$room2 === void 0 ? void 0 : _roomTypeMapping$room2[bathRoomType];
  }
}
export function getBathRoomSelectedPMSRoomTypesAndSpecialRequests(t, isPremPlusAccFeatureFlag, roomTypeSelections, bathroomSelections, basketDetailsState, language) {
  var _basketDetailsState$s2;
  var selectedPMSRoomTypes = [];
  var selectedSpecialRequests = [];
  var accessibleRoomIndex = 0;
  var isPremierPlus = isPremierPlusAccessibleRoomByText(basketDetailsState.roomClass, language);
  (_basketDetailsState$s2 = basketDetailsState.selectedRate) === null || _basketDetailsState$s2 === void 0 || (_basketDetailsState$s2 = _basketDetailsState$s2.roomTypes) === null || _basketDetailsState$s2 === void 0 || _basketDetailsState$s2.forEach(roomType => {
    var _roomType$rooms8;
    if ((roomType === null || roomType === void 0 ? void 0 : roomType.roomType) !== ACCESSIBLE_ROOM_TYPE) {
      var _roomType$rooms6, _roomType$rooms7;
      accessibleRoomIndex++;
      var accessibleRooms = roomType === null || roomType === void 0 || (_roomType$rooms6 = roomType.rooms) === null || _roomType$rooms6 === void 0 ? void 0 : _roomType$rooms6.filter(room => isAccessibleRoomType(room === null || room === void 0 ? void 0 : room.pmsRoomType));
      var selectedRoom = (accessibleRooms === null || accessibleRooms === void 0 ? void 0 : accessibleRooms[0]) || (roomType === null || roomType === void 0 || (_roomType$rooms7 = roomType.rooms) === null || _roomType$rooms7 === void 0 ? void 0 : _roomType$rooms7[0]);
      selectedSpecialRequests.push(selectedRoom === null || selectedRoom === void 0 ? void 0 : selectedRoom.specialRequests);
      selectedPMSRoomTypes.push(selectedRoom === null || selectedRoom === void 0 ? void 0 : selectedRoom.pmsRoomType);
      return;
    }
    var isPremierPlusAccessibleRoomSelected = isPremierPlus && (roomType === null || roomType === void 0 ? void 0 : roomType.roomType) === ACCESSIBLE_ROOM_TYPE;
    var pmsRoomType = getPMSRoomTypeByRoomTypeAndBathroom(t, isPremPlusAccFeatureFlag, accessibleRoomIndex, roomTypeSelections, bathroomSelections, isPremierPlusAccessibleRoomSelected);
    accessibleRoomIndex++;
    if (!pmsRoomType) {
      return;
    }
    var room = roomType === null || roomType === void 0 || (_roomType$rooms8 = roomType.rooms) === null || _roomType$rooms8 === void 0 ? void 0 : _roomType$rooms8.find(room => {
      return (room === null || room === void 0 ? void 0 : room.pmsRoomType) === pmsRoomType;
    });
    if (loweredBathRoomTypes.includes(pmsRoomType)) {
      var _room$specialRequests;
      selectedSpecialRequests.push(room === null || room === void 0 || (_room$specialRequests = room.specialRequests) === null || _room$specialRequests === void 0 ? void 0 : _room$specialRequests.filter(specialRequest => specialRequest !== 'WETR'));
    }
    if (wetBathRoomTypes !== null && wetBathRoomTypes !== void 0 && wetBathRoomTypes.includes(pmsRoomType)) {
      var _room$specialRequests2;
      selectedSpecialRequests.push(room === null || room === void 0 || (_room$specialRequests2 = room.specialRequests) === null || _room$specialRequests2 === void 0 ? void 0 : _room$specialRequests2.filter(specialRequest => specialRequest !== 'LOWB'));
    }
    selectedPMSRoomTypes.push(pmsRoomType);
  });
  return {
    selectedPMSRoomTypes,
    selectedSpecialRequests
  };
}
export function getAccessibleRoomSelectedPMSRoomTypesAndSpecialRequests(roomTypeSelections, accessibleRoomTypeSelections, basketDetailsState, roomAvailability) {
  var _basketDetailsState$s3;
  var selectedPMSRoomTypes = [];
  var selectedSpecialRequests = [];
  var accessibleRoomIndex = 0;
  (_basketDetailsState$s3 = basketDetailsState.selectedRate) === null || _basketDetailsState$s3 === void 0 || (_basketDetailsState$s3 = _basketDetailsState$s3.roomTypes) === null || _basketDetailsState$s3 === void 0 || _basketDetailsState$s3.forEach(roomType => {
    var _roomType$rooms1, _room$specialRequests3;
    if ((roomType === null || roomType === void 0 ? void 0 : roomType.roomType) !== ACCESSIBLE_ROOM_TYPE) {
      var _roomType$rooms9, _roomType$rooms0;
      accessibleRoomIndex++;
      var accessibleRooms = roomType === null || roomType === void 0 || (_roomType$rooms9 = roomType.rooms) === null || _roomType$rooms9 === void 0 ? void 0 : _roomType$rooms9.filter(room => isAccessibleRoomType(room === null || room === void 0 ? void 0 : room.pmsRoomType));
      var selectedRoom = (accessibleRooms === null || accessibleRooms === void 0 ? void 0 : accessibleRooms[0]) || (roomType === null || roomType === void 0 || (_roomType$rooms0 = roomType.rooms) === null || _roomType$rooms0 === void 0 ? void 0 : _roomType$rooms0[0]);
      selectedSpecialRequests.push(selectedRoom === null || selectedRoom === void 0 ? void 0 : selectedRoom.specialRequests);
      selectedPMSRoomTypes.push(selectedRoom === null || selectedRoom === void 0 ? void 0 : selectedRoom.pmsRoomType);
      return;
    }
    var pmsRoomType = getPMSRoomTypeByRoomType(accessibleRoomIndex, roomTypeSelections, accessibleRoomTypeSelections, roomAvailability, roomType === null || roomType === void 0 ? void 0 : roomType.rooms);
    accessibleRoomIndex++;
    if (!pmsRoomType) {
      return;
    }
    var room = roomType === null || roomType === void 0 || (_roomType$rooms1 = roomType.rooms) === null || _roomType$rooms1 === void 0 ? void 0 : _roomType$rooms1.find(room => (room === null || room === void 0 ? void 0 : room.pmsRoomType) === pmsRoomType);
    if (room !== null && room !== void 0 && (_room$specialRequests3 = room.specialRequests) !== null && _room$specialRequests3 !== void 0 && _room$specialRequests3.length) selectedSpecialRequests.push(room === null || room === void 0 ? void 0 : room.specialRequests);
    selectedPMSRoomTypes.push(pmsRoomType);
  });
  return {
    selectedPMSRoomTypes,
    selectedSpecialRequests
  };
}
export function getPMSRoomTypeByRoomType(accessibleRoomIndex, roomTypeSelections, accessibleRoomTypeSelections, roomAvailability, rooms) {
  var _roomAvailability$fin, _roomTypeMapping$room3;
  var roomType = roomTypeSelections[accessibleRoomIndex];
  var accessibleRoomType = accessibleRoomTypeSelections[accessibleRoomIndex];
  var room = rooms.find(_ref2 => {
    var specialRequests = _ref2.specialRequests;
    return accessibleRoomType === ROOM_TYPE.STANDARD_ACCESSIBLE && (specialRequests.includes('LOWB') || specialRequests.includes('WETR')) || specialRequests.includes('BFRE');
  });
  return (roomAvailability === null || roomAvailability === void 0 || (_roomAvailability$fin = roomAvailability.find(_ref3 => {
    var code = _ref3.code,
      availableCount = _ref3.availableCount;
    return (room === null || room === void 0 ? void 0 : room.pmsRoomType) === code && availableCount > 0;
  })) === null || _roomAvailability$fin === void 0 ? void 0 : _roomAvailability$fin.code) || ((_roomTypeMapping$room3 = roomTypeMapping[roomType]) === null || _roomTypeMapping$room3 === void 0 ? void 0 : _roomTypeMapping$room3[accessibleRoomType]);
}
export function getRoomClassTextForGAllery(basketDetailsState, language, isPremPlusAccFeatureFlag) {
  var _basketDetailsState$s4;
  var roomClasscode = getSelectedRoomClassCode(basketDetailsState === null || basketDetailsState === void 0 ? void 0 : basketDetailsState.roomClass, language) || '';
  var roomType = (basketDetailsState === null || basketDetailsState === void 0 || (_basketDetailsState$s4 = basketDetailsState.selectedRate) === null || _basketDetailsState$s4 === void 0 || (_basketDetailsState$s4 = _basketDetailsState$s4.roomTypes[0]) === null || _basketDetailsState$s4 === void 0 ? void 0 : _basketDetailsState$s4.roomType) || '';
  var isPremierPlus = isPremierPlusAccessibleRoomByCode(roomClasscode, roomType, isPremPlusAccFeatureFlag);
  return isPremierPlus || isPremPlusAccFeatureFlag && roomClasscode === RoomClassCodes.PREMIER_PLUS_ROOM ? PREMIER_PLUS_ACCESSIBLE : ACCESSIBLE;
}
export function filterRoomsByRoomClass() {
  var roomTypesData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allowedRoomClass = arguments.length > 1 ? arguments[1] : undefined;
  var isPremPlusAccFeatureFlag = arguments.length > 2 ? arguments[2] : undefined;
  if (!allowedRoomClass || !isPremPlusAccFeatureFlag) {
    return roomTypesData;
  }
  return roomTypesData === null || roomTypesData === void 0 ? void 0 : roomTypesData.map(roomGroup => {
    var _roomGroup$rooms;
    return _objectSpread(_objectSpread({}, roomGroup), {}, {
      rooms: roomGroup === null || roomGroup === void 0 || (_roomGroup$rooms = roomGroup.rooms) === null || _roomGroup$rooms === void 0 ? void 0 : _roomGroup$rooms.filter(room => (room === null || room === void 0 ? void 0 : room.roomClass) === allowedRoomClass)
    });
  }).filter(roomGroup => {
    var _roomGroup$rooms2;
    return (roomGroup === null || roomGroup === void 0 || (_roomGroup$rooms2 = roomGroup.rooms) === null || _roomGroup$rooms2 === void 0 ? void 0 : _roomGroup$rooms2.length) > 0;
  });
}
export function isItBarrierFree(selectedRoomCodes, barrierFreeRoomsSpecialRequestCodes, selectedRoomClassCode) {
  return selectedRoomCodes === null || selectedRoomCodes === void 0 ? void 0 : selectedRoomCodes.some(group => {
    var _group$rooms;
    return group === null || group === void 0 || (_group$rooms = group.rooms) === null || _group$rooms === void 0 ? void 0 : _group$rooms.some(room => {
      var _room$specialRequests4;
      return (room === null || room === void 0 ? void 0 : room.roomClass) === selectedRoomClassCode && ((_room$specialRequests4 = room.specialRequests) === null || _room$specialRequests4 === void 0 ? void 0 : _room$specialRequests4.some(code => barrierFreeRoomsSpecialRequestCodes === null || barrierFreeRoomsSpecialRequestCodes === void 0 ? void 0 : barrierFreeRoomsSpecialRequestCodes.includes(code)));
    });
  });
}
export function hasMatchingPromotionCode(promoCode, roomRates) {
  if (!promoCode || !Array.isArray(roomRates)) return false;
  return roomRates === null || roomRates === void 0 ? void 0 : roomRates.some(item => (item === null || item === void 0 ? void 0 : item.promotionCode) === promoCode);
}
export function getActivePromotionCode(promotionBannerData, promoId) {
  var banner = promotionBannerData;
  var bannerCode = banner === null || banner === void 0 ? void 0 : banner.promotionCode;
  var isWithinWindow = banner === null || banner === void 0 ? void 0 : banner.isWithinPromoWindow;
  var isPromoEnabled = banner === null || banner === void 0 ? void 0 : banner.showPromo;
  if (promoId && isPromoEnabled && promoId === bannerCode && isWithinWindow) {
    return promoId;
  }
  if (isPromoEnabled && isWithinWindow && bannerCode) {
    return bannerCode;
  }
  return '';
}
export function getRoomRatesWithRateInformation(roomRates, rateClassifications) {
  var _window;
  if (typeof window === 'undefined') {
    return roomRates;
  }
  var _ref4 = ((_window = window) === null || _window === void 0 ? void 0 : _window.location) || {},
    hostname = _ref4.hostname;
  var roomRatesWithRateInformation = [];
  var _loop = function _loop(roomRate) {
    var rateClassification = rateClassifications === null || rateClassifications === void 0 ? void 0 : rateClassifications.find(el => (el === null || el === void 0 ? void 0 : el.rateClassification) === (roomRate === null || roomRate === void 0 ? void 0 : roomRate.ratePlanCode) || (el === null || el === void 0 ? void 0 : el.ratePlanCode) === (roomRate === null || roomRate === void 0 ? void 0 : roomRate.ratePlanCode));
    if (!(rateClassification !== null && rateClassification !== void 0 && rateClassification.rateName) || !(rateClassification !== null && rateClassification !== void 0 && rateClassification.rateDescription)) {
      if (/localhost|www\.((qa\w+)|dev|dit|sit)\.premierinn\.digital/.test(hostname)) {
        console.log("[HDP] No rate name or description for rate with rate plan code: ".concat(roomRate === null || roomRate === void 0 ? void 0 : roomRate.ratePlanCode));
      }
      return 1;
    }
    roomRatesWithRateInformation.push(roomRate);
  };
  for (var roomRate of roomRates) {
    if (_loop(roomRate)) continue;
  }
  return roomRatesWithRateInformation;
}
export var getDashboardBasket = function () {
  var _ref5 = _asyncToGenerator(function* (basketReference) {
    return yield executeGraphQLQuery(GET_DASHBOARD_BASKET, {
      basketReference
    }, result => {
      var _result$data;
      return result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.basket;
    });
  });
  return function getDashboardBasket(_x) {
    return _ref5.apply(this, arguments);
  };
}();
export var getBrandForUnleashContext = function () {
  var _ref7 = _asyncToGenerator(function* (_ref6) {
    var language = _ref6.language,
      brand = _ref6.brand,
      slug = _ref6.slug,
      basketReference = _ref6.basketReference;
    if (brand) {
      return brand;
    }
    if (slug) {
      var slugPath = Array.isArray(slug) ? slug.join('/') : slug;
      var hotelInformation = yield staticHotelInformationIB("/hotels/".concat(slugPath), language);
      return hotelInformation === null || hotelInformation === void 0 ? void 0 : hotelInformation.brand;
    }
    if (basketReference) {
      var bookingInfo = yield getDashboardBasket(basketReference);
      if (!(bookingInfo !== null && bookingInfo !== void 0 && bookingInfo.hotelId)) {
        return undefined;
      }
      var _hotelInformation = yield getHotelInformationIB(bookingInfo.hotelId, language);
      return _hotelInformation === null || _hotelInformation === void 0 ? void 0 : _hotelInformation.brand;
    }
    return undefined;
  });
  return function getBrandForUnleashContext(_x2) {
    return _ref7.apply(this, arguments);
  };
}();
export function extractPromoBoxData(isPromotionsInHotelAvailabilityEnabled, hotelAvailability, promotionBannerData) {
  var _latestPromotionBanne;
  var latestPromotionBanner = isPromotionsInHotelAvailabilityEnabled ? hotelAvailability === null || hotelAvailability === void 0 ? void 0 : hotelAvailability.promotionsInformation : promotionBannerData;
  var source = latestPromotionBanner !== null && latestPromotionBanner !== void 0 ? latestPromotionBanner : promotionBannerData;
  if (!source) {
    return undefined;
  }
  return _objectSpread(_objectSpread({}, source), {}, {
    promoBox: (_latestPromotionBanne = latestPromotionBanner === null || latestPromotionBanner === void 0 ? void 0 : latestPromotionBanner.promoBox) !== null && _latestPromotionBanne !== void 0 ? _latestPromotionBanne : promotionBannerData === null || promotionBannerData === void 0 ? void 0 : promotionBannerData.promoBox
  });
}